import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopalgharcab() {



  const cardData =
  {
    keyword: 'Mumbai to Palghar Cab',
    heading: 'Shambhu Cabs: Mumbai to Palghar Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Palghar Cab services, providing safe, comfortable, and hassle-free travel for families, corporate travelers, tourists, and weekend getaway seekers heading to Palghar. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Palghar with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your trip convenient, stress-free, and memorable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Palghar cab services.',

    top: 'Top Places to Visit in Palghar with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Tungareshwar Wildlife Sanctuary",
    "description": "Tungareshwar Wildlife Sanctuary, located near Palghar, is a lush forested area spread over the Western Ghats. It is home to leopards, deer, wild boars, and various bird species. Visitors can enjoy trekking, nature walks, and birdwatching while exploring the scenic hills and streams. The sanctuary provides a peaceful retreat from urban life and is ideal for adventure and nature enthusiasts."
  },
  {
    "title": "Kelva Beach",
    "description": "Kelva Beach is a serene coastal destination in Palghar, known for its golden sands, palm trees, and calm waters. It is less crowded compared to other beaches, making it perfect for picnics, sunset viewing, photography, and leisurely walks along the shore. Local shacks offer fresh seafood and refreshments, enhancing the beach experience."
  },
  {
    "title": "Arnala Fort and Beach",
    "description": "Arnala Fort, located on a small island near Arnala Beach, is a historic Portuguese-era fort with thick stone walls and bastions. Accessible by a short ferry ride, it offers stunning views of the Arabian Sea. Visitors enjoy exploring the fort, its watchtowers, and nearby beach, combining history with coastal beauty."
  },
  {
    "title": "Vasai Fort",
    "description": "Vasai Fort, also called Bassein Fort, is a 16th-century Portuguese fort featuring grand ramparts, bastions, and ancient ruins. The fort offers panoramic views of the surrounding countryside and the sea. It is a significant historical site reflecting colonial architecture and Maratha history, attracting photographers and history enthusiasts."
  },
  {
    "title": "Dahanu Beach",
    "description": "Dahanu Beach, located near Palghar, is famous for its peaceful coastline, tidal mudflats, and fishing villages. The beach is ideal for enjoying sunsets, birdwatching, and sampling local seafood. Seasonal Chikoo orchards nearby make it a popular spot for fruit picking and experiencing local agricultural culture."
  },
  {
    "title": "Shirsad Hot Springs",
    "description": "Shirsad Hot Springs, situated in the Palghar district, are natural sulfur springs believed to have medicinal properties. Visitors can enjoy the warm water baths, surrounded by lush greenery. The springs provide a unique wellness experience combined with scenic nature walks."
  },
  {
    "title": "Vikramgad Fort",
    "description": "Vikramgad Fort, an ancient Maratha fort, sits atop a hill offering panoramic views of the surrounding forests and villages. Trekking to the fort is a favorite activity among adventure enthusiasts. The fort is surrounded by dense greenery and has remnants of old temples and structures that showcase historical architecture."
  },
  {
    "title": "Dahanu Fruit Orchards",
    "description": "Dahanu, near Palghar, is famous for its Chikoo (Sapodilla) orchards. Visitors can walk through the orchards, pick fresh fruits, and enjoy local produce. The orchards offer a blend of agriculture tourism, scenic beauty, and interaction with local farmers, making it a unique rural experience."
  },
  {
    "title": "Bordi Beach",
    "description": "Bordi Beach is a quiet and less-commercialized beach near Palghar, ideal for relaxing and enjoying the coastal scenery. The beach is surrounded by dense coconut plantations and offers a calm environment for family outings, photography, and evening walks along the shore."
  },
  {
    "title": "Palghar Market and Local Attractions",
    "description": "The Palghar Market area showcases the local culture, handicrafts, and traditional cuisine. Visitors can explore local shops, taste street food, and interact with the community to experience the regional lifestyle. It is an ideal place for cultural immersion and souvenir shopping while visiting Palghar."
  }
],




"services": [
  {
    "name": "Mumbai Palghar Taxi Service",
    "description": "Reliable Mumbai Palghar Taxi Service providing comfortable and timely travel from Mumbai to Palghar for all travelers."
  },
  {
    "name": "Palghar from Mumbai Cab",
    "description": "Palghar from Mumbai Cab offers safe and convenient transportation for both short and long-distance trips."
  },
  {
    "name": "One Way Cab Mumbai Palghar",
    "description": "One Way Cab Mumbai Palghar is ideal for travelers needing a single-direction journey with affordable fares."
  },
  {
    "name": "Affordable Taxi Mumbai Palghar",
    "description": "Affordable Taxi Mumbai Palghar ensures budget-friendly travel without compromising on safety or comfort."
  },
  {
    "name": "SUV Cab Mumbai Palghar",
    "description": "SUV Cab Mumbai Palghar provides spacious rides for families or groups traveling from Mumbai to Palghar."
  },
  {
    "name": "Sedan Taxi Mumbai Palghar",
    "description": "Sedan Taxi Mumbai Palghar offers a comfortable and economical option for small groups or solo travelers."
  },
  {
    "name": "24x7 Cab Mumbai Palghar",
    "description": "24x7 Cab Mumbai Palghar ensures round-the-clock taxi availability for early departures or late-night arrivals."
  },
  {
    "name": "Fast Cab Mumbai Palghar",
    "description": "Fast Cab Mumbai Palghar provides optimized routes for quick and efficient travel."
  },
  {
    "name": "Premium Taxi Mumbai Palghar",
    "description": "Premium Taxi Mumbai Palghar offers luxury vehicles for a comfortable and stylish journey."
  },
  {
    "name": "Local Cab Mumbai to Palghar",
    "description": "Local Cab Mumbai to Palghar provides convenient point-to-point service within Mumbai and surrounding areas."
  },
  {
    "name": "Corporate Cab Mumbai Palghar",
    "description": "Corporate Cab Mumbai Palghar caters to business travelers seeking punctual and professional transport."
  },
  {
    "name": "Safe Taxi Mumbai Palghar",
    "description": "Safe Taxi Mumbai Palghar ensures passenger safety with well-maintained vehicles and experienced drivers."
  },
  {
    "name": "Mumbai Palghar Highway Cab",
    "description": "Mumbai Palghar Highway Cab offers smooth travel on highways with reliable service for long-distance journeys."
  },
  {
    "name": "Best Cab Mumbai Palghar",
    "description": "Best Cab Mumbai Palghar provides top-rated services with professional drivers and comfortable vehicles."
  },
  {
    "name": "AC Taxi Mumbai Palghar",
    "description": "AC Taxi Mumbai Palghar ensures a cool and comfortable ride, perfect for all weather conditions."
  },
  {
    "name": "Reliable Cab Mumbai Palghar",
    "description": "Reliable Cab Mumbai Palghar offers dependable travel services with timely pickups and drop-offs."
  }
],

"tableData": [
  ["Mumbai Palghar Taxi Service", "Palghar from Mumbai Cab"],
  ["One Way Cab Mumbai Palghar", "Affordable Taxi Mumbai Palghar"],
  ["SUV Cab Mumbai Palghar", "Sedan Taxi Mumbai Palghar"],
  ["24x7 Cab Mumbai Palghar", "Fast Cab Mumbai Palghar"],
  ["Premium Taxi Mumbai Palghar", "Local Cab Mumbai to Palghar"],
  ["Corporate Cab Mumbai Palghar", "Safe Taxi Mumbai Palghar"],
  ["Mumbai Palghar Highway Cab", "Best Cab Mumbai Palghar"],
  ["AC Taxi Mumbai Palghar", "Reliable Cab Mumbai Palghar"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Palghar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Palghar cab services, perfect for long-distance travel, family trips, business journeys, and comfortable intercity commutes."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable ride from Mumbai to Palghar."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Palghar route, ensuring safe driving, timely arrivals, and a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Palghar cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your Mumbai to Palghar journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Palghar journey smooth, comfortable, and worry-free."
  }
]


















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Palghar?',
    answer: 'Yes, Shambhu Cabs offers convenient and reliable cab services from Mumbai to Palghar, ensuring a comfortable and smooth journey to this serene town.',
  },
  {
    question: 'How can I book a cab from Mumbai to Palghar?',
    answer: 'You can easily book a cab from Mumbai to Palghar through our website, mobile app, or by contacting our 24x7 customer support team for a quick and hassle-free booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Palghar cab bookings?',
    answer: 'Shambhu Cabs provides a variety of vehicles for your Mumbai to Palghar journey, including sedans, SUVs, luxury cars, and larger vehicles like Tempo Travellers for family or group travel.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Palghar journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route to Palghar, ensuring a safe, smooth, and pleasant ride.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Palghar trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points in Mumbai and Palghar for a more personalized and convenient travel experience.',
  },
  {
    question: 'Is the Mumbai to Palghar cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides 24x7 cab services for your journey from Mumbai to Palghar, ensuring you can travel at a time that suits you best.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Palghar trip?',
    answer: 'Yes, all our vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene protocols to ensure your well-being during the trip.',
  },
  {
    question: 'What payment options are available for Mumbai to Palghar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all bookings from Mumbai to Palghar.',
  },
  {
    question: 'Is customer support available during my Mumbai to Palghar trip?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you throughout your journey from Mumbai to Palghar.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'My trip from Mumbai to Palghar with Shambhu Cabs was great. The driver was friendly, the car was clean and comfortable, and the journey was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'The Mumbai to Palghar trip was comfortable and stress-free thanks to Shambhu Cabs. Excellent service, and I highly recommend their services for short trips.',
    rating: 5,
  },
];

















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const mumbaiPalgharCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Palghar Cab",
  "serviceType": "Outstation / Local Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-palghar-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Palghar cab services. Book affordable SUV, sedan, and premium cabs for one-way, corporate, or local travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "480",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-palghar-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Palghar, India" }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Palghar Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Palghar cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, corporate, or local travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Palghar Taxi Service, Palghar from Mumbai Cab, One Way Cab Mumbai Palghar, Affordable Taxi Mumbai Palghar, SUV Cab Mumbai Palghar, Sedan Taxi Mumbai Palghar, 24x7 Cab Mumbai Palghar, Fast Cab Mumbai Palghar, Premium Taxi Mumbai Palghar, Local Cab Mumbai to Palghar, Corporate Cab Mumbai Palghar, Safe Taxi Mumbai Palghar, Mumbai Palghar Highway Cab, Best Cab Mumbai Palghar, AC Taxi Mumbai Palghar, Reliable Cab Mumbai Palghar"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiPalgharCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopalgharcab;